"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var ScriptProvider_1 = __importDefault(require("../Common/ScriptProvider"));
var VgsContainer = function (_a) {
    var children = _a.children, vgsConfig = _a.vgsConfig;
    var _b = __read(React.useState(false), 2), isVgsScriptLoaded = _b[0], setVgsScriptLoaded = _b[1];
    var _c = __read(React.useState(''), 2), vgsErrorMessage = _c[0], setVgsErrorMessage = _c[1];
    var checkVgsScript = function () { return Boolean(window.VGSCollect); };
    React.useEffect(function () {
        checkVgsScript();
    }, []);
    /**
     * The VGS script might take some time to load and hence retrying
     * to account for the load time.
     */
    var vgsScriptOnload = React.useCallback(function () {
        if (checkVgsScript()) {
            setVgsScriptLoaded(true);
            return;
        }
        var iterations = 0;
        var interval = setInterval(function () {
            iterations = iterations + 1;
            if (iterations >= 100) {
                clearInterval(interval);
                setVgsErrorMessage('Failed to load VGS vendor script');
                return;
            }
            if (checkVgsScript()) {
                clearInterval(interval);
                setVgsScriptLoaded(true);
                return;
            }
        }, 50);
    }, []);
    return (React.createElement(ScriptProvider_1["default"], { onLoad: vgsScriptOnload, source: vgsConfig.SCRIPT_URL, sourceId: "vgs-script-js" },
        React.createElement(React.Fragment, null, children(isVgsScriptLoaded, vgsErrorMessage))));
};
exports["default"] = VgsContainer;
